import { render, staticRenderFns } from "./StatView.vue?vue&type=template&id=6a794d16&scoped=true&"
import script from "./StatView.vue?vue&type=script&lang=js&"
export * from "./StatView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a794d16",
  null
  
)

export default component.exports